import type { PropsWithChildren } from "react";

import styled from "styled-components";

const MetricsWidgetContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    min-height: 190px;
    gap: 8px;
`;

export const WidgetGrid = ({ children }: PropsWithChildren) => {
    return <MetricsWidgetContainer>{children}</MetricsWidgetContainer>;
};
